import { useEffect } from 'react';
import { usePlatform } from '../providers/PlatformProvider';
import { useSafeBack } from './useSafeBack';

export function usePlatformBack(): void {
  const platform = usePlatform();
  const safeBack = useSafeBack();

  useEffect(() => {
    platform.showBackButton(safeBack);
    return () => {
      platform.hideBackButton();
    };
  }, [platform, safeBack]);
}
